document.addEventListener('click', function(e) {
    const dataHrefElement = e.target.closest('[data-href]');
    
    if (dataHrefElement) {
        const exclude = dataHrefElement.getAttribute('data-href-exclude');
        if (exclude) {
            const excludeClasses = exclude.split(',').map(cls => cls.trim());
            if (excludeClasses.some(cls => e.target.closest(`.${cls}`))) return;
        }
    }

    if (dataHrefElement && !['A', 'INPUT', 'BUTTON'].includes(e.target.tagName)) {
        e.preventDefault();
        
        const link = dataHrefElement.querySelector('a:first-of-type');
        if (link) {
            const href = link.getAttribute('href');
            const target = link.getAttribute('target') || '_self';
            window.open(href, target);
        }
    }
});

document.addEventListener('click', function(e) {
    const element = e.target.closest('[data-href-simulated-click]');
    
    if (element) {
        const exclude = element.getAttribute("data-href-simulated-click");
        if (e.target.classList.contains(exclude) && exclude !== '') {
            return;
        } else {
            e.preventDefault();
            
            const link = element.querySelector('a:first-of-type');
            if (link) {
                // Simulate the click event on the link
                link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }
        }
    }
});